import Icons, { IconsProps } from '../Icons';

// https://www.zhangxinxu.com/sp/svgo/

export default function (props: IconsProps) {
  return (
    <Icons {...props}>
      <path d="M18.053 21.12v-2.875h-2.875v-.958h2.875v-2.875h.958v2.875h2.875v.958h-2.875v2.875h-.958z" />
      <path d="M3.39 20.066v-.958l6.325-3.45c1.054.287 2.204.383 3.259.191.191 0 .383-.095.575-.095a4.523 4.523 0 0 0 1.629-.671c.479-.288.958-.575 1.341-.959 1.246-1.15 1.917-2.779 1.917-4.6 0-3.545-2.97-6.516-6.708-6.516-3.642 0-6.613 2.875-6.613 6.516 0 2.396 1.342 4.505 3.354 5.655l-6.229 3.45v2.683h12.171v-1.246H3.391zM6.265 9.429c0-2.971 2.492-5.463 5.559-5.463 3.066 0 5.558 2.396 5.558 5.463 0 2.97-2.492 5.462-5.558 5.462-3.067-.096-5.559-2.492-5.559-5.462z" />
    </Icons>
  );
}
